<template>
  <!-- 文件下载 -->
  <div>
    <!-- 文件内容 -->
    <div class="maincon">
      <img src="~@/assets/image/common/img1.webp" alt="" />
      <div class="condet">
        <div
          class="detitem"
          v-for="(item, index) in datas.dataList"
          :key="index"
          @click="goDetail(item.temPlateUrl)"
        >
          <span>{{ item.temPlateName }}</span>
          <span class="righticon"></span>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottombtn">
      <button @click="$router.back()">{{ $t('common.back') }}</button>
      <button @click="showFix()">{{ datas.btnText }}</button>
    </div>

    <!-- 弹窗 -->
    <div class="fixbg" v-if="showFixCon" @click="closeFix()"></div>
    <div class="fixcon1" v-if="showFixCon">
      <p>{{ $t('text.fileDownload.tit') }}</p>
      <div class="checkdet">
        <div
          class="checkitem"
          v-for="(item, index) in datas.dataList"
          :key="index"
        >
          <label>
            <input
              type="checkbox"
              @change="checkItem($event)"
              data-index="index"
            />
          </label>
          <span>{{ item.temPlateName }}</span>
        </div>
        <div class="checkitem">
          <input
            type="text"
            :placeholder="$t('text.fileDownload.placeHolder')"
            v-model="emailInput"
          />
        </div>
      </div>
      <p @click="download()">{{ $t('text.fileDownload.email') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 附件数据
    datas: {
      type: Object
    }
  },
  data() {
    return {
      showFixCon: false,
      emailInput: ''
    }
  },
  methods: {
    checkItem: function (event) {
      if (event.target.checked === true) {
        event.target.parentNode.classList.add('on')
      } else {
        event.target.checked === false
        event.target.parentNode.classList.remove('on')
      }
    },
    showFix() {
      this.showFixCon = true
    },
    closeFix() {
      this.showFixCon = false
    },
    // 去详情
    goDetail(url) {
      console.log(url)
      window.location.href = url
    },
    // 下载
    download() {
      let selectarr = []
      //   /\w{3}@/
      let reg =
        /[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/
      if (!this.emailInput || !reg.test(this.emailInput)) {
        if (this.$i18n.locale == 'zh-cn') {
          this.$toast('请输入正确的邮箱')
        } else {
          this.$toast('please enter your vaild email')
        }
        return
      } else {
        let arr = document.querySelectorAll("input[type='checkbox']")
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].checked === true) {
            selectarr.push(i)
          }
        }
        console.log(this.emailInput, selectarr)
        this.$emit('download', this.emailInput, selectarr)
        this.showFixCon = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.maincon {
  background-color: #fff;
  padding-top: 60px;
  & > img {
    width: 68.13%;
    margin: 0 auto;
  }
  .condet {
    width: 81.33%;
    margin: 38px auto 0;
    .detitem {
      font-size: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      span:first-child {
        max-width: 90%;
        text-align: left;
        line-height: 18px;
      }
      .righticon {
        width: 8px;
        height: 13px;
        background: url(~@/assets/image/common/righticon.png) center center
          no-repeat;
        background-size: 100% 100%;
        opacity: 0.5;
      }
    }
  }
}
.bottombtn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 15px 0 20px;
  font-size: 15px;
  button {
    text-align: center;
    border: none;
    border-radius: 5px;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    background: rgba(51, 51, 51, 1);
    box-shadow: 0px 10px 30px 0px rgba(51, 51, 51, 0.3);
    margin: 0 auto;
    color: #ffe7a6;
    width: 40%;
    outline: 0;
  }
}
.fixbg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
}

.fixcon1 {
  position: absolute;
  background-color: #fff;
  width: 94.66%;
  margin: 0 auto;
  border-radius: 15px;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  p {
    &:nth-child(1) {
      padding: 23px 25px;
      font-size: 15px;
      color: #333;
      text-align: left;
    }
    &:last-child {
      font-size: 0.4rem;
      padding: 20px 0;
      color: #ffe7a6;
      font-size: 15px;
      border-bottom-left-radius: 15px;
      background-color: #333333;
      border-top: 1px solid #333333;
      border-bottom-right-radius: 15px;
    }
  }
  .checkdet {
    padding: 0 25px;
    .checkitem {
      display: flex;
      padding: 6px 0;
      label {
        width: 15px;
        height: 15px;
        border: 1px solid #999999;
        margin-right: 8px;
        input {
          width: 100%;
          height: 100%;
          opacity: 0;
          vertical-align: top;
        }
        &.on {
          width: 15px;
          height: 15px;
          border: none;
          background: url(~@/assets/image/common/ccheck.png) center center
            no-repeat;
          background-size: contain;
        }
      }
      span {
        font-size: 13px;
        color: #333;
        text-align: left;
        line-height: 16px;
      }
      &:last-child {
        padding: 15px 20px;
        margin: 12px 0 20px;
        font-size: 15px;
        background: rgba(245, 245, 245, 1);
        border-radius: 10px;
        input {
          width: 100%;
          border: none;
          outline: 0;
          background-color: transparent;
          &::placeholder {
            color: #ccc;
          }
        }
      }
    }
  }
}
</style>
